import React, { Component } from "react";
import _ from "lodash";
import isEmpty from "lodash/isEmpty";
import {
    Container,
    Card,
    CardHeader,
    Row,
    Col,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import {
    Button as Button1,
    Message,
    Icon,
    Header,
    Modal as Modal1,
    Tab,
    Label,
    Menu,
    Table
} from 'semantic-ui-react'
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ListGroupCollapse from "../../common/ListGroupCollapse";
import { Link, withRouter } from "react-router-dom";
import RXInfo from "../Prescription/RXInfo";
import Markers from "../Prescription/Markers";
import PrescriptionHistory from "../Prescription/PrescriptionHistory";
import {
    getPrescriptions,
    postPrescriptions,
    dispensePrescription,
    getPrescriptionsById,
    getPrescriptionHistory,
    getPrescriptionByNumber, presc_modal_view, getDurInfo,
} from "../../../actions/mqttAction";
import Spinner from "../../common/Spinner";
import soundFile from "../../../assets/Electronic_Chime-KevanGC-495939803.wav";
import Allergies from "../Prescription/Allergies";
import Warnings from "../Prescription/Warnings";
import Magnifier from "react-magnifier";

class Approved extends Component {
    constructor() {
        super();
        this.state = {
            approved: {},
            collapse: false,
            currentImage: {},
            headers: {},
            modal: false,
            showDur: false,
            rejectModal: false,
            prescriptionModal: false,
            dispensePrescription: false,
            approvedById: [],
            ndcImage: "",
            prescriptionByNumber: {},
            direct_dispense: false,
            requireConsult: false,
            ppmRquired: false,
            isTechnician: false,
        };
        this.showDUR = this
            .showDUR
            .bind(this)

        this.toggleDurModal = this
            .toggleDurModal
            .bind(this);
        this.onChange = this
            .onChange
            .bind(this);
        this.toggle = this
            .toggle
            .bind(this);
        this.dispense = this
            .dispense
            .bind(this);
        this.restock = this
            .restock
            .bind(this);
        this.toggleModal = this
            .toggleModal
            .bind(this);
        this.togglePrescriptionModal = this
            .togglePrescriptionModal
            .bind(this);
        this.dispensePrescription = this
            .dispensePrescription
            .bind(this);
        this.dispenseAndClose = this
            .dispenseAndClose
            .bind(this);
        this.closeAll = this
            .closeAll
            .bind(this);
        this.directDispense = this
            .directDispense
            .bind(this);

        this.rejectModal = this
            .rejectModal
            .bind(this);
        this.sound = new Audio(soundFile);
    }

    componentDidMount() {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let branchName;
        branchName = localStorage.branch
            ? localStorage.branch
            : "Chama";
        this.state.isTechnician = ("Technician".toUpperCase() == this.props.auth.user.roles[0].toUpperCase())

        this
            .props
            .getPrescriptionByNumber(orgId, `branchName=${this.props.prescription[0].branchName}`, this.props.prescriptionNumber, this.props.prescription[0].prescriptionStatus);
        this
            .props
            .getPrescriptionHistory(orgId, `${this.props.prescription[0].branchName}`, this.props.patientId);
        this
            .props
            .getPrescriptionsById(orgId, `${this.props.prescription[0].branchName}`, this.props.patientId, "Approved");

        this.setState({
            ...this.state,
            prescriptionByNumber: this.props.prescription,
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let headers = {};
        if (Object.keys(nextProps.mqtt.prescriptionByNumber).length > 0) {
            const prescriptionByNumber = nextProps.mqtt.prescriptionByNumber;
            const prescriptionHistory = nextProps.mqtt.prescriptionHistory;
            let ndcImage;
            prescriptionByNumber
                .prescriptionImageUrls
                .forEach(images => {
                    if (images.imageType === "ndcPillImage") {

                        ndcImage = "" + images.imageUrl;
                        this.setState({ ndcImage: ndcImage });
                    }
                });

            console.log('prescriptionByNumber.patientInfo.patientAdditionalInfo'
                , prescriptionByNumber.patientInfo.patientAdditionalInfo)
            headers.prescriptionDetails = {
                header: "Prescription Details",
                content: (<RXInfo
                    draft={prescriptionByNumber}
                    style={{
                        backgroundColor: "#fff"
                    }} />)
            };
            headers.markers = {
                header: "Markers",
                content: (<Markers
                    prescription={prescriptionByNumber.patientInfo.patientAdditionalInfo} prescriptionStatus={prescriptionByNumber.prescriptionStatus}
                    buttonDisplay={{
                        display: "none"
                    }} />)
            };
            headers.medicationHistory = {
                header: "Medication History",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.medicationHistory)
                            ? (<PrescriptionHistory
                                prescriptionHistory={prescriptionHistory}
                                prescriberInfo={prescriptionByNumber.prescriberInfo} />)
                            : (
                                <span>No medication history available</span>
                            )}
                    </div>
                )
            };
            headers.allergies = {
                header: "Allergies",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.allergies)
                            ? (<Allergies prescriptionHistory={prescriptionHistory} />)
                            : (
                                <span>No allergies available</span>
                            )}
                    </div>
                )
            };
            headers.warnings = {
                header: "Warnings",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionHistory.warnings)
                            ? (<Warnings prescriptionHistory={prescriptionHistory} />)
                            : (
                                <span>No warnings available</span>
                            )}
                    </div>
                )
            };
            headers.auditLogs = {
                header: "Audit Logs",
                content: (
                    <div>
                        {!_.isEmpty(prescriptionByNumber.auditLogs)
                            ? (
                                <ul>
                                    {prescriptionByNumber
                                        .auditLogs
                                        .map(auditLog => (
                                            <li key={auditLog}>{auditLog}</li>
                                        ))}
                                </ul>
                            )
                            : (
                                <span>No Audit Logs available</span>
                            )}
                    </div>
                )
            };
            this.setState({ approved: nextProps.mqtt.prescriptionByNumber, headers: headers });
            if (Object.keys(nextProps.mqtt.durInfo).length > 0) {
                this.setState({ durInfo: nextProps.mqtt.durInfo });
            }
            if (nextProps.mqtt.prescriptionByNumber.durInfo &&
                nextProps.mqtt.prescriptionByNumber.durInfo.interactionCount && !this.state.durInfo) {
                this.props.getDurInfo(nextProps.mqtt.prescriptionByNumber);

            }

        }
        if (nextProps.mqtt.prescriptionsById) {
            this.setState({ approvedById: nextProps.mqtt.prescriptionsById });
        }


    }

    onChange = e => {


        if (e.target.value === "Other") {
            this.setState({
                ...this.state,
                direct_dispense: true
            })
        }

        this.setState({


            [e.target.name]: e.target.value
        })
    };

    toggle(headers) {
        this.setState({
            collapse: this.state.collapse === headers
                ? null
                : headers
        });
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    togglePrescriptionModal() {
        this.setState({
            prescriptionModal: !this.state.prescriptionModal
        });
    }

    showDUR(toShow) {
        this.setState({
            ...this.state,
            showDur: toShow
        })
    }
    closeDur() {
    }

    toggleDurModal() {
        let toShow = this.state.showDur;
        this.setState({
            ...this.state,
            showDur: !toShow
        })
    }

    getDurModal() {

        let prescription = this.props.mqtt.prescriptionByNumber;
        let durModal = <div></div>
        if (Object.keys(prescription).length > 0) {
            if (prescription && prescription.durInfo) {
                let mbody = ""
                var ReactDOMServer = require('react-dom/server');
                var HtmlToReactParser = require('html-to-react').Parser;
                var htmlToReactParser = new HtmlToReactParser();
                var reactElement = htmlToReactParser.parse("<div></div>");
                if (this.state.durInfo) {
                    reactElement = htmlToReactParser.parse(this.state.durInfo.professionalMonograph);
                }



                let modalBody;
                let severityLevel = prescription.durInfo.seviorityLevel

                if (severityLevel === "Major") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong>
                                    <h4 >
                                        Interraction Count :
                                        <span
                                            style={{
                                                color: "teal",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.interactionCount}</span>
                                    </h4>
                                </strong>
                            </Col>
                            <Col md="1" lg="1"></Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong>
                                    <h4 >
                                        Severity :
                                        <span
                                            className=" text-capitalize"
                                            style={{
                                                color: "red",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.seviorityLevel}</span>
                                    </h4>
                                </strong>
                            </Col>
                        </Row>

                        {reactElement}
                    </div>
                } else if (severityLevel === "medium") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong>
                                    <h4 >
                                        Interraction Count :
                                        <span
                                            style={{
                                                color: "teal",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.interactionCount}</span>
                                    </h4>
                                </strong>
                            </Col>
                            <Col md="1" lg="1"></Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong>
                                    <h4 >
                                        Severity :
                                        <span
                                            className=" text-capitalize"
                                            style={{
                                                color: "orange",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.seviorityLevel}</span>
                                    </h4>
                                </strong>
                            </Col>
                        </Row>

                        {reactElement}
                    </div>
                } else if (severityLevel === "low") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong>
                                    <h4 >
                                        Interraction Count :
                                        <span
                                            style={{
                                                color: "teal",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.interactionCount}</span>
                                    </h4>
                                </strong>
                            </Col>
                            <Col md="1" lg="1"></Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong>
                                    <h4 >
                                        Severity :
                                        <span
                                            className=" text-capitalize"
                                            style={{
                                                color: "#007bff",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.seviorityLevel}</span>
                                    </h4>
                                </strong>
                            </Col>
                        </Row>

                        {reactElement}
                    </div>
                } else if (severityLevel === "Unknown") {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong>
                                    <h4 >
                                        Interraction Count :
                                        <span
                                            style={{
                                                color: "teal",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.interactionCount}</span>
                                    </h4>
                                </strong>
                            </Col>
                            <Col md="1" lg="1"></Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong>
                                    <h4 >
                                        Severity :
                                        <span
                                            className=" text-capitalize"
                                            style={{
                                                color: "grey",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.seviorityLevel}</span>
                                    </h4>
                                </strong>
                            </Col>
                        </Row>

                        {reactElement}
                    </div>
                } else {
                    modalBody = <div className="dur-interactions-headings">
                        <Row>
                            <Col md="5" lg="5" className="text-center ml-2">
                                <strong>
                                    <h4 >
                                        Interraction Count :
                                        <span
                                            style={{
                                                color: "teal",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.interactionCount}</span>
                                    </h4>
                                </strong>
                            </Col>
                            <Col md="1" lg="1"></Col>
                            <Col md="5" lg="5" className="text-center mr-2">
                                <strong>
                                    <h4 >
                                        Severity :
                                        <span
                                            className=" text-capitalize"
                                            style={{
                                                color: "grey",
                                                fontSize: "1.5rem"
                                            }}>{prescription.durInfo.seviorityLevel}</span>
                                    </h4>
                                </strong>
                            </Col>
                        </Row>

                        {reactElement}
                    </div>
                }
                // var reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);

                durModal = <div>
                    <Modal
                        isOpen={this.state.showDur}
                        backdrop={true}
                        className="dur-modal bg-light"
                        centered
                        dialogClassName="custom-modal"
                        bsClass="my-modal">
                        <ModalHeader toggle={this.toggleDurModal}>
                            <h4>
                                <strong>DRUG UTILIZATION REVIEW</strong>
                            </h4>
                        </ModalHeader>
                        <ModalBody>
                            {modalBody}
                        </ModalBody>
                    </Modal>
                </div>
            } else { }
        }
        return durModal;
    }

    dispensePrescription() {
        this.setState({
            dispensePrescription: !this.state.dispensePrescription
        });
    }

    dispenseAndClose() {
        this.dispensePrescription();
        this.togglePrescriptionModal();
    }

    closeAll() {
        this.setState({ dispensePrescription: false, prescriptionModal: false });
        this.dispense();
    }

    deletePrescription(prescriptionNumber) {
        let approved = this.state.approvedById;
        let index = approved.findIndex(x => x.rxInfo.prescriptionNumber === prescriptionNumber);
        approved.splice(index, 1);
        this.setState({ approvedById: approved });
    }

    rejectModal() {
        this.setState({
            rejectModal: !this.state.rejectModal
        });
    }

    reject = () => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let approved = this.props.mqtt.prescriptionByNumber;
        approved.rxInfo.rejectReason = this.state.rejectReason;
        approved.rxInfo.rxStatus = "Rejected";

        this
            .props
            .postPrescriptions(orgId, approved, this.props.history);
        this
            .props
            .presc_modal_view(false, {}, '', '');
    };

    restock = () => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let approved = this.props.mqtt.prescriptionByNumber;

        approved.rxInfo.rxStatus = "Restock";


        this
            .props
            .postPrescriptions(orgId, approved, this.props.history);
        this
            .props
            .presc_modal_view(false, {}, '', '');
    };

    dispense = () => {
        let orgId;
        if (this.props.auth.user.orgId)
            orgId = this.props.auth.user.orgId;
        else
            orgId = 1;
        let approved = this.state.approvedById;
        approved.map((approved) => {
            if (approved.rxInfo.prescriptionNumber == this.props.mqtt.prescriptionByNumber.rxInfo.prescriptionNumber) {
                approved.rxInfo.rxStatus = "CounsellingPending";
                approved.prescriptionStatus = "CounsellingPending"
            } else {
                approved.rxInfo.rxStatus = "Dispensed";
                approved.prescriptionStatus = "Dispensed"
            }

        }
        );
        this
            .sound
            .play();
        this
            .props
            .dispensePrescription(orgId, approved, this.props.history);
        this
            .props
            .presc_modal_view(false, {}, '', '');
    };

    render() {
        const { headers, approvedById, ndcImage } = this.state;
        const { prescriptionByNumber, loading } = this.props.mqtt;
        //let prescriptionByNumber = this.state.prescriptionByNumber;
        let approvedPrescription,
            approvedPrescriptions,
            imageUrls = [];
        const isDispensed =
            Object.keys(prescriptionByNumber).length > 0 &&
            prescriptionByNumber.rxInfo.rxStatus === "Dispensed";
        if (Object.keys(prescriptionByNumber).length === 0) {
            approvedPrescription = <Spinner />;
        } else {
            if (Object.keys(prescriptionByNumber).length > 0) {

                let prescription = this.props.mqtt.prescriptionByNumber;
                let durItem = <div></div>;
                if (prescription.durInfo && prescription.durInfo.interactionCount) {
                    let seviorityLevel = prescription.durInfo.seviorityLevel;

                    if (seviorityLevel === "Major") {
                        durItem = <Menu
                            compact
                            className="ml-4"
                            onClick={() => {
                                this.showDUR(true);
                            }}>
                            <Menu.Item as='a' color="red">
                                {/* <Icon name='mail' /> */}
                                <span
                                    style={{
                                        color: "red"
                                    }}>
                                    DUR Found</span>
                                <Label color='red' floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    } else if (seviorityLevel === "low") {
                        durItem = <Menu
                            compact
                            className="ml-4"
                            onClick={() => {
                                this.showDUR(true);
                            }}>
                            <Menu.Item as='a' color="#007bff">
                                {/* <Icon name='mail' /> */}
                                <span
                                    style={{
                                        color: "#007bff"
                                    }}>
                                    DUR Found</span>
                                <Label
                                    color='#007bff'
                                    style={{
                                        color: "white",
                                        backgroundColor: "#007bff"
                                    }}
                                    floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    } else if (seviorityLevel === "medium") {
                        durItem = <Menu
                            compact
                            className="ml-4"
                            onClick={() => {
                                this.showDUR(true);
                            }}>
                            <Menu.Item as='a' color="#007bff">
                                {/* <Icon name='mail' /> */}
                                <span
                                    style={{
                                        color: "orange"
                                    }}>
                                    DUR Found</span>
                                <Label
                                    color='#007bff'
                                    style={{
                                        color: "black",
                                        backgroundColor: "orange"
                                    }}
                                    floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    } else if (seviorityLevel === "Unknown") {
                        durItem = <Menu
                            compact
                            className="ml-4"
                            onClick={() => {
                                this.showDUR(true);
                            }}>
                            <Menu.Item as='a' color="grey">
                                {/* <Icon name='mail' /> */}
                                <span
                                    style={{
                                        color: "black"
                                    }}>
                                    DUR Found</span>
                                <Label
                                    color='#007bff'
                                    style={{
                                        color: "black",
                                        backgroundColor: "grey"
                                    }}
                                    floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    } else {
                        durItem = <Menu
                            compact
                            className="ml-4"
                            onClick={() => {
                                this.showDUR(true);
                            }}>
                            <Menu.Item as='a' color="grey">
                                {/* <Icon name='mail' /> */}
                                <span
                                    style={{
                                        color: "black"
                                    }}>
                                    DUR Found</span>
                                <Label
                                    color='#007bff'
                                    style={{
                                        color: "black",
                                        backgroundColor: "grey"
                                    }}
                                    floating>
                                    {prescription.durInfo.interactionCount}
                                </Label>
                            </Menu.Item>
                        </Menu>
                    }

                }

                const approvedAuditLog = !_.isEmpty(prescriptionByNumber.auditLogs)
                    ? prescriptionByNumber
                        .auditLogs
                        .slice()
                        .reverse()
                        .find(log => /status changed to approved/i.test(log))
                    : undefined;
                const approvedByMatch = approvedAuditLog && approvedAuditLog.match(/\bby\s+(.+)$/i);
                const approvedByName = approvedByMatch ? approvedByMatch[1].trim() : "";
                const bannerStyle = {
                    color: "#ffff",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    opacity: "0.55",
                    padding: "6px 0",
                    fontWeight: "bolder",
                    fontSize: "15px",
                    borderRadius: "0.2rem"
                };
                const listItems = prescriptionByNumber
                    .prescriptionImageUrls
                    .map(images => (
                        <Card>
                            <span className="text-center">
                                <h5>
                                    {images.imageType !== "ndcPillImage"
                                        ? (
                                            <div
                                                className=""
                                                style={{
                                                    position: "absolute",
                                                    textAlign: "center",
                                                    zIndex: "888",
                                                    width: "100%"
                                                }}>
                                                <div style={bannerStyle}>
                                                    {images
                                                        .imageType
                                                        .toUpperCase()}
                                                </div>
                                                {images.imageType === "prescriptionImage"
                                                    && approvedByName
                                                    && prescriptionByNumber.patientInfo.patientAdditionalInfo.ppmRequired
                                                    ? (
                                                        <div style={bannerStyle}>
                                                            {`PMPRequired Approved by ${approvedByName}`}
                                                        </div>
                                                    )
                                                    : ("")}
                                            </div>
                                        )
                                        : ("")}
                                </h5>
                            </span>
                            {/* <img
                src={images.imageType !== "ndcPillImage" ? images.imageUrl : ""}
              /> */}
                            <Magnifier
                                onError={this.addDefaultSrc}
                                src={images.imageType !== "ndcPillImage"
                                    ? images.imageUrl
                                    : ""}
                                mgShape="square"
                                zoomFactor={0.5}
                                mgWidth={500}
                                mgHeight={200} />
                        </Card>
                    ));
                approvedPrescription = (
                    <div>
                        <CardHeader
                            style={{
                                backgroundColor: "transparent",
                                borderBottom: "none"
                            }}>
                            <Row>
                                <Col lg="6" md="4">
                                    <div className="float-left">
                                        <h2
                                            className="text-capitalize"
                                            style={{
                                                margin: "none!important"
                                            }}>
                                            {prescriptionByNumber.patientInfo.firstName.toUpperCase()}{" "} {prescriptionByNumber.patientInfo.lastName.toUpperCase()}
                                        </h2>
                                        <h5 className="d-inline text-muted text-info font-bigger">
                                            <i class="fas fa-birthday-cake fa-1x mr-1 teal"></i> {prescriptionByNumber.patientInfo.dateOfBirth}
                                        </h5>
                                        <h5 className="d-inline text-muted ml-4 text-info font-bigger">
                                            <i class="fas fa-address-card mr-1 fa-1x teal"></i>{prescriptionByNumber.patientInfo.address}
                                        </h5>
                                    </div>
                                </Col>
                                <Col></Col>

                                <Col className="button-column">
                                    {isDispensed ? (
                                        <Badge className="d-inline text-center" color="success" style={{ fontSize: "1rem", padding: "0.5rem 1rem" }}>
                                            <i className="fas fa-check mr-1" />
                                            Dispensed
                                        </Badge>
                                    ) : this.state.isTechnician ? <Button1.Group >
                                        <Button1
                                            disabled
                                            color="teal"
                                            size="md"
                                            className="mx-2"
                                            onClick={() => {
                                                this.rejectModal();
                                            }}>
                                            <i className="fas fa-times mr-1" />
                                            Reject
                                        </Button1><Button1.Or />
                                        <Button1
                                            color="info"
                                            size="md"
                                            className="mx-2"
                                            onClick={() => {
                                                this.restock();
                                            }}>
                                            <i className="fas fa-times mr-1" />
                                            Re-stock
                                        </Button1><Button1.Or />
                                        <Button1
                                            color="teal"
                                            size="md"
                                            className="mx-2"
                                            onClick={() => {
                                                this.togglePrescriptionModal();
                                            }}>
                                            <i className="fas fa-check mr-1" />
                                            Dispense
                                        </Button1>
                                    </Button1.Group> : <Button1.Group className="button-column">

                                        <Button1
                                            color="red"
                                            size="medium"
                                            className="mx-2"
                                            onClick={() => {
                                                this.rejectModal();
                                            }}>
                                            Reject
                                        </Button1></Button1.Group>}
                                </Col>

                            </Row>
                        </CardHeader>
                        <CardHeader
                            style={{
                                backgroundColor: "transparent",
                                borderBottom: "none"
                            }}
                            className="mt-3">
                            <Row>
                                <Col md="5">
                                    <Row className="py-2">
                                        <Col md="5">
                                            <span className="font-style mb-1 text-capitalize">
                                                NDC: {prescriptionByNumber.rxInfo.ndcNumber}
                                            </span>
                                            <img src={ndcImage} alt="" />
                                        </Col>
                                        <Col md="7" className="pt-4">
                                            <Table>
                                                <tbody className="font-style">
                                                    <tr>
                                                        <td>
                                                            {" "}
                                                            <div className="d-inline-block">
                                                                <div className="d-inline-block">
                                                                    <i className="d-inline fas fa-edit text-info mr-2" />
                                                                    <h3 className="d-inline">
                                                                        {prescriptionByNumber.rxInfo.prescriptionNumber
                                                                        }
                                                                    </h3>
                                                                    {prescriptionByNumber.patientInfo.patientAdditionalInfo.ppmRequired ? <Badge color="danger" pill className="ml-1">
                                                                        PMPRequired*
                                                                    </Badge> : null}
                                                                    <Badge className="d-inline text-center" color="success ml-2">
                                                                        {isDispensed ? "Dispensed" : "Approved"}
                                                                    </Badge>
                                                                    {durItem}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span className="text-info" /> {prescriptionByNumber.rxInfo.rxName}-
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span className="text-info" /> {prescriptionByNumber.rxInfo.strength}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    {Object
                                        .keys(headers)
                                        .map((key, index) => (index === 2 ?
                                            <ListGroupCollapse key={index}
                                                content={headers[key]}
                                                isOpen={true}
                                                toggle={this.toggle}
                                                icon="fas fa-plus-square mr-2" />
                                            : <ListGroupCollapse
                                                key={index}
                                                content={headers[key]}
                                                isOpen={this.state.collapse === headers[key]}
                                                toggle={this.toggle}
                                                icon="fas fa-plus-square mr-2" />))}
                                </Col>
                                <div className="col-md-7 py-4">
                                    <Container className="photo-card-scroll">
                                        {listItems}
                                    </Container>
                                </div>
                            </Row>
                        </CardHeader>
                    </div>
                );
            } else
                approvedPrescription = <h4>No prescriptions found</h4>;
        }
        if (loading) {
            approvedPrescriptions = <Spinner />;
        } else {
            if (Object.keys(approvedById).length > 0 && Object.keys(prescriptionByNumber).length > 0) {
                approvedPrescriptions = approvedById.map(approved => (
                    <Table.Row className="text-center" key={approved.rxInfo.prescriptionNumber}>
                        <Table.Cell className="text-capitalize">
                            <strong>
                                {approved.patientInfo.firstName}
                                {approved.patientInfo.lastName}
                            </strong>
                            <div className="text-info">
                                {approved.patientInfo.dateOfBirth}
                            </div>
                        </Table.Cell>
                        <Table.Cell>
                            <strong>{approved.rxInfo.prescriptionNumber}</strong>
                            <div className="text-info">{approved.rxInfo.rxName}</div>
                        </Table.Cell>
                        {approved.rxInfo.prescriptionNumber !== prescriptionByNumber.rxInfo.prescriptionNumber
                            ? (
                                <Table.Cell
                                    collapsing
                                    onClick={this
                                        .deletePrescription
                                        .bind(this, approved.rxInfo.prescriptionNumber)}>
                                    <i
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        className="fas fa-trash text-danger" />
                                </Table.Cell>
                            )
                            : (
                                <Table.Cell collapsing>
                                    <i className="fas fa-check text-success" />
                                </Table.Cell>
                            )}
                    </Table.Row>
                ));
            }
        }
        let toShow = <Card className="card-width">
            {approvedPrescription}
            <div className="wrapper clearfix px-4 pt-2">
                <CardHeader
                    style={{
                        backgroundColor: "transparent",
                        borderBottom: "none"
                    }}>
                    {/* <Button color="info" size="md" className=" mx-2" onClick={this.toggleModal}>
                    <i className="fas fa-times-circle mr-1"/>
                    Exit
                </Button> */}
                    <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                        <ModalHeader>
                            <h3>Warning</h3>
                        </ModalHeader>
                        <ModalBody>Your changes will be discarded! Proceed?</ModalBody>
                        <ModalFooter>
                            <Button tag={Link} to={"/pharmacist-dashboard"} color="secondary">
                                Confirm
                            </Button>
                            <Button color="secondary" onClick={this.toggleModal}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <div className="float-right">
                        {/* <Button
                        color="info"
                        size="md"
                        className="mx-2"
                        onClick={() => {
                        this.rejectModal();
                    }}>
                        <i className="fas fa-times mr-1"/>
                        Reject
                    </Button>
                    <Button
                        color="info"
                        size="md"
                        className="mx-2"
                        onClick={() => {
                        this.restock();
                    }}>
                        <i className="fas fa-times mr-1"/>
                        Re-stock
                    </Button>
                    <Button
                        color="info"
                        size="md"
                        className="mx-2"
                        onClick={() => {
                        this.togglePrescriptionModal();
                    }}>
                        <i className="fas fa-check mr-1"/>
                        Dispense
                    </Button> */}
                        <Modal isOpen={this.state.rejectModal} toggle={this.toggleModal}>
                            <ModalHeader>
                                <h3>Please enter a reason for rejecting</h3>
                            </ModalHeader>
                            <ModalBody>
                                <Input
                                    type="text"
                                    name="rejectReason"
                                    onChange={this.onChange}
                                    placeholder="Reject reason" />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.reject}>
                                    Confirm
                                </Button>
                                <Button color="secondary" onClick={this.rejectModal}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                        {/* <Button
                        color="info"
                        size="md"
                        className="mx-2"
                        onClick={() => {
                        this.restock();
                    }}>
                        <i className="fas fa-times mr-1"/>
                        Re-stock
                    </Button>
                    <Button
                        color="info"
                        size="md"
                        className="mx-2"
                        onClick={() => {
                        this.togglePrescriptionModal();
                    }}>
                        <i className="fas fa-check mr-1"/>
                        Dispense
                    </Button> */}
                        <Modal
                            isOpen={this.state.prescriptionModal}
                            toggle={this.togglePrescriptionModal}>
                            <ModalHeader style={{ backgroundColor: "#0e566c", color: "white" }}>Dispense Prescription(s)</ModalHeader>
                            <ModalBody>
                                <Table fixed singleLine>
                                    <Table.Header className="font-style">
                                        <Table.Row className="text-muted text-center">
                                            <Table.HeaderCell>Name & D.o.B</Table.HeaderCell>
                                            <Table.HeaderCell width={10}>
                                                Prescription # & Name
                                            </Table.HeaderCell>
                                            <Table.HeaderCell></Table.HeaderCell>
                                        </Table.Row>
                                        {approvedPrescriptions}
                                    </Table.Header>
                                </Table>
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.dispenseAndClose} color="secondary">
                                    Next
                                </Button>
                                <Button color="secondary" onClick={this.togglePrescriptionModal}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </Modal>
                        {this.getDurModal()}

                        <Modal
                            isOpen={this.state.dispensePrescription}
                            toggle={this.dispensePrescription}>
                            <ModalHeader style={{ backgroundColor: "#0e566c", color: "white" }}>Dispense Medication</ModalHeader>
                            <ModalBody>
                                <Table fixed singleLine>
                                    <Table.Header className="font-style">
                                        <Table.Row className="text-muted">
                                            <Table.HeaderCell>
                                                Dispense Date
                                            </Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell>
                                                <Input type="date" name="date" value={new Date().toISOString().substr(0, 10)} onChange={this.onChange} />
                                            </Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell>Reason</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell>
                                                <select
                                                    name="accessRole"
                                                    onChange={this.onChange}
                                                    className="form-control form-border">
                                                    <option defaultValue={""}>Select a Reason</option>
                                                    <option value="Pharmacist on-site">
                                                        Pharmacist On-site
                                                    </option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Header>
                                </Table>
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.dispenseAndClose} color="secondary">
                                    Back
                                </Button>
                                {this.getCounselButtons()}
                            </ModalFooter>
                        </Modal>
                    </div>
                </CardHeader>
            </div>
        </Card>
        if (loading) {
            toShow = <Spinner />
        }
        return (
            toShow
        );
    }

    getCounselButtons() {

        let counsel_buttons = <Button color="secondary" onClick={this.closeAll}>
            Go to Counselling
        </Button>

        if (this.state.direct_dispense) {
            counsel_buttons = <Button color="secondary" onClick={this.directDispense}>
                Dispense
            </Button>
        }

        return counsel_buttons;
    }

    directDispense() {
        let orgId = 1;
        let prescription = this.state.approvedById;
        prescription.map(
            prescription => (prescription.rxInfo.rxStatus = "Dispensed")
        );
        this.props.dispensePrescription(orgId, prescription, this.props.history);
    }
}

Approved.propTypes = {
    getPrescriptionHistory: PropTypes.func.isRequired,
    getPrescriptions: PropTypes.func.isRequired,
    getPrescriptionsById: PropTypes.func.isRequired,
    postPrescriptions: PropTypes.func.isRequired,
    getPrescriptionByNumber: PropTypes.func.isRequired,
    mqtt: PropTypes.object.isRequired,
    presc_modal_view: PropTypes.func.isRequired,
    getDurInfo: PropTypes.func.isRequired,
    dispensePrescription: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default connect(mapStateToProps, {
    postPrescriptions,
    dispensePrescription,
    getPrescriptionHistory,
    getPrescriptionsById,
    getPrescriptions,
    getPrescriptionByNumber, presc_modal_view, getDurInfo
})((Approved));
